import { createContext, useContext, useEffect, useRef, useState } from "react";

const QuoteEditorContext = createContext(null);

const emptyQuote = { client_id: null, client_name: "", title: "", items: [], labor_cost: 0, margin_pct: 30 };

export function QuoteEditorProvider({ children }) {
  const [editing, setEditing] = useState(null);
  const [editId, setEditId] = useState(null);
  const draftKeyRef = useRef(null);

  const openEdit = (q) => {
    const id = q?.id || null;
    const key = `gr_quote_draft_${id || "new"}`;
    const base = q
      ? { client_id: q.client_id, client_name: q.client_name, title: q.title || "", items: q.items || [], labor_cost: q.labor_cost || 0, margin_pct: q.margin_pct ?? 30 }
      : { ...emptyQuote, items: [] };
    let draft = null;
    try { draft = JSON.parse(localStorage.getItem(key) || "null"); } catch (_) { /* borrador inválido: usar datos guardados */ }
    draftKeyRef.current = key;
    setEditId(id);
    setEditing(draft || base);
  };

  const closeEdit = () => {
    setEditing(null);
    setEditId(null);
    draftKeyRef.current = null;
  };

  const clearDraft = () => {
    if (draftKeyRef.current) localStorage.removeItem(draftKeyRef.current);
    draftKeyRef.current = null;
  };

  useEffect(() => {
    if (!editing || !draftKeyRef.current) return;
    const timer = setTimeout(() => localStorage.setItem(draftKeyRef.current, JSON.stringify(editing)), 250);
    return () => clearTimeout(timer);
  }, [editing]);

  return (
    <QuoteEditorContext.Provider value={{ editing, setEditing, editId, openEdit, closeEdit, clearDraft }}>
      {children}
    </QuoteEditorContext.Provider>
  );
}

export const useQuoteEditor = () => useContext(QuoteEditorContext);
